// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> axia-residential-arc-living-preferred -> the-otis
// Generated: 2026-10-01T17:22:53.838Z
// Counts: 2 design, 81 content, 23 slot group, 5 collection binding, 9 section, 10 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Find A Home at Macon’s Best Address</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 70px;\">Living Life In Tune</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore Macon, GA step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to The Otis</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.heading": {
    "overrideType": "VALUE",
    "customValue": " ",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibilitystatement.intro": {
    "overrideType": "VALUE",
    "customValue": "<p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-map.config_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_repli_id"
  },
  "applynowactions.show_application_block": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "callrail-tracking.account_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_account_hash"
  },
  "callrail-tracking.company_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_call_rail_company_id"
  },
  "contactus.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "elise-schedule-tour-iframe.height_mobile": {
    "overrideType": "VALUE",
    "customValue": "1600",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.height": {
    "overrideType": "VALUE",
    "customValue": "2000",
    "generatedValue": null,
    "mappedField": null
  },
  "iframe-embed.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "preferredemployerprogram.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Exclusive Apartment Offers for Employees in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.source": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.scheduler_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "scheduleatour.show_tour_scheduler": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.height": {
    "overrideType": "VALUE",
    "customValue": "1400",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_eliseai_tour_scheduler_url"
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d9c4e-88d3-779f-bf5c-b528b705eeac.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 28px;\"><strong>Life Looks Better Here</strong></span></p><p>Nestled in the heart of Macon, GA, The Otis redefines comfort with a variety of spacious floor plans, from one to three bedrooms. Enjoy resort-style amenities like a shimmering pool, pet-friendly parks, and a vibrant clubhouse. Experience maintenance-free living where your lifestyle flourishes—<a class=\"richtext-link\" href=\"/schedule-a-tour\">come see what makes The Otis unique!</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 28px;\"><strong>Find Your Perfect Home</strong></span></p><p>At The Otis in Macon, GA, your ideal living space awaits with thoughtfully designed one, two, and three-bedroom floor plans. Each layout harmonizes comfort and style, perfect for any lifestyle. Browse our available apartment homes today and envision your new sanctuary!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Otis in Macon, GA, vibrant living meets modern comfort. Our diverse floor plans—from one to three bedrooms—cater to every lifestyle, complemented by <a class=\"richtext-link\" href=\"/amenities\">luxury amenities</a> like a resort-style pool, pet-friendly dog park, and a sleek clubhouse. Picture yourself thriving in this welcoming, gated community!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to The Otis in Macon, GA, where modern living meets relaxation. Choose from spacious one, two, or three-bedroom apartments featuring sleek quartz countertops and walk-in closets. Enjoy community perks like a resort-style pool, pet-friendly <a class=\"richtext-link\" href=\"/amenities\">amenities</a>, and easy highway access. Uncover your perfect home using our interactive map today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Otis in Macon, GA, your ideal home awaits among vibrant attractions. Dive into adventure at Urban Air Trampoline Park, enjoy leisure at Amerson River Park, or immerse yourself in art at the Museum of Arts and Sciences. Check out the rich tapestry of local favorites just steps away! <a class=\"richtext-link\" href=\"/contact\">Contact us Today!</a></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 28px;\"><strong>We Love Pets!</strong></span></p><p>The Otis cherishes your furry companions as much as you do, and we’re excited to welcome yours to our pet-friendly apartment community. Our thoughtfully designed homes and amenities cater not just to you but also to your pets, ensuring they feel right at home. For more details about our pet policy and how we can accommodate your beloved pet, please don’t hesitate to <a class=\"richtext-link\" href=\"/contact\">reach out to us</a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerprogram.employers_list": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>First Responders</p></li><li><p>Educators</p></li><li><p>Military &amp; Veterans</p></li><li><p>Law Enforcement</p></li><li><p>Delta Airlines</p></li><li><p>Medical Personnel</p></li><li><p>School System Employees</p></li><li><p>Amazon Fulfillment Center</p></li><li><p>Chik-fil-la</p></li><li><p>Postal Workers</p></li><li><p>Georgia Power</p></li><li><p>Lockheed Martin</p></li><li><p>Hartsfield-Jackson Airport</p></li><li><p>Government Employees</p></li><li><p>Bibb County BOE</p></li><li><p>Macon College</p></li><li><p>Wesleyan College</p></li><li><p>Mercer University</p></li><li><p>Tractor Supply Distribution Center</p></li><li><p>Frito Lay</p></li><li><p>TysonThanks</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Life feels more connected at The Otis. Whether you're beginning a new career, growing your family, or simply looking for a place to relax and recharge, you'll find the comfort, convenience, and welcoming atmosphere you've been searching for.</p><p>Our thoughtfully designed one, two, and three-bedroom apartment homes feature spacious layouts and modern finishes that make everyday living effortless. Enjoy stylish quartz countertops, sleek black appliances, generous walk-in closets, and functional living spaces designed with your lifestyle in mind.</p><p>Conveniently located in Macon with quick access to I-475, The Otis places shopping, dining, entertainment, employers, and everyday conveniences just minutes from home, making it easy to enjoy everything the city has to offer.</p><p>When it's time to unwind, you'll love our resort-style swimming pool, poolside grilling area, sand volleyball court, fitness center, clubhouse, dog park, and playground. Whether you're spending time with friends, staying active, or simply enjoying a quiet afternoon, there's something for everyone.</p><p>At The Otis, our professional onsite management and maintenance teams are committed to creating a community that's welcoming, well cared for, and enjoyable to call home. Inside our gated community, you'll enjoy the peace of mind and convenience of maintenance-free living, along with features like washer and dryer connections, high-speed internet access, and select homes with pre-wired security systems.</p><p>Whether you're searching for your first apartment or your next home, The Otis offers the space, comfort, and service you've been looking for. Schedule your tour today and discover why so many love calling The Otis home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Otis in Macon, GA, your ideal home awaits with <a class=\"richtext-link\" href=\"/floor-plans\">thoughtfully designed one, two, and three-bedroom floor plans</a>. Experience vibrant living in a thriving community. Curious about life here? Don't miss the chance to hear our residents' stories—schedule your tour today and envision your new beginning!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 28px;\"><strong>Take A Look Inside</strong></span></p><p>Experience the vibrant community and inviting amenities – take a virtual tour today to find your perfect home!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_online_leasing_url"
      }
    }
  },
  "_template:hyperlocal::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "featuring/apartment-with-pool-monroe-30655::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019fa5e8-f694-750b-a962-cff754fe9bb1.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A fun-filled pool party with diverse friends enjoying colorful floats together."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02eb-1520-755b-ac57-7b725730aed0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Building entrance and leasing center of a multifamily property."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-b6a0-734f-ab19-8b034cbdad58.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "King-size bed with white bedding and decorative pillows in a bright bedroom with wood dresser and accent chair."
      }
    }
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-b6a0-734f-ab19-8b034cbdad58.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "King-size bed with white bedding and decorative pillows in a bright bedroom with wood dresser and accent chair."
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54fd-154a-75c8-be5c-daee8fd0dc32.webp"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54fc-fa60-74ac-a86a-1e6007ef6bd6.webp"
      }
    }
  },
  "floorplanslist.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54fc-077e-736d-9100-59b190ada6d2.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019d54fd-1610-730b-8a86-df1d01a6cfeb.webp"
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-e25a-763a-9575-c830e61c09df.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Lobby with fireplace, seating, and The Otis logo."
      }
    }
  },
  "hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Floor plans"
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[34].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[34].poi_featured_image_media.alt_text"
      }
    }
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[30].poi_featured_image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "neighborhood_pois[30].poi_featured_image_media.alt_text"
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019fa5f4-3316-7097-b831-d8b54f25a9ee.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Happy laughing diverse friends in smart casual clothes sitting at table in cozy cafe and eating delicious food near smiling Asian waitress"
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019fa5e7-4527-705a-a0d3-48c7ee732164.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A cheerful group of friends enjoys a celebration with cake on a sunny rooftop."
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019fa5e8-2d98-71be-a6f7-79ae7744ccab.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A Bengal cat and Yorkshire Terrier playfully reach for a feathered toy indoors."
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167337/019e02ea-ae3b-7489-909e-cc65aba662d5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dining area and kitchen with island, black appliances, and white cabinetry."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  },
  "propertyoverview.apartment_amenities": {
    "limit": 6,
    "hiddenIds": null,
    "orderedIds": [
      "custom_cc2396c7-1d2c-438a-9ebb-a626af5d6990",
      "custom_79fad51e-443a-4e5f-8252-737abf6ae8c2",
      "custom_6d5a716a-0aec-4612-89ea-4e596e216875",
      "custom_05e9bbff-1ed6-42aa-9bd6-57123e711d6b",
      "custom_37b6afcc-60d6-4f43-8d02-91474eb7a074",
      "custom_21b04659-a626-496f-a99f-50cb4c68a54a",
      "custom_0cc8fa3e-d230-4be5-a73b-c8cd2a43f90d",
      "custom_1f229729-2eeb-4248-9fe9-6d989de3945f",
      "custom_6de8c2bb-fa81-4558-b3b3-0156756defc4",
      "custom_6e268765-50de-4fd3-817e-f00c661d2cdb",
      "custom_fdd5f289-6188-4eff-9ef5-72bf92e36576",
      "custom_a962aae7-cea5-456f-977d-5189a085b156",
      "custom_83db48b7-d349-433c-9ea5-8a56e6fbf905",
      "custom_cfea7dc2-d9e4-42fe-9654-f2583212fd1b",
      "custom_a783215a-44c5-4137-a9cd-099c7d7991b3",
      "custom_a1a10322-ce3c-460b-b8ad-3d0d25ba7acd",
      "custom_ecb82d36-ee37-4c48-9893-b16ee036ec62",
      "custom_3a3d3c01-9e03-4ca7-b0e5-1688339f80e3"
    ],
    "hiddenIndices": null,
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      17,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16
    ],
    "customItems": null
  },
  "propertyoverview.community_amenities": {
    "limit": 6,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "callrail-tracking",
      "blockId": "callrail-tracking",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 9,
      "visible": false,
      "gridSpanMobile": 12
    }
  ],
  "schedule-a-tour": [
    {
      "sectionId": "elise-schedule-tour-iframe",
      "blockId": "elise-schedule-tour-iframe",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "_section.block:iframe-embed": {
    "properties": {
      "overflow": "hidden"
    }
  },
  "amenities-blurb.text": {
    "properties": {
      "--vibe-color-hyperlink": "#00306b"
    }
  },
  "gallery-blurb.text": {
    "properties": {
      "--vibe-color-hyperlink": "#00306b"
    }
  },
  "interactive-map-blurb.text": {
    "properties": {
      "--vibe-color-hyperlink": "#00306b"
    }
  },
  "neighborhood-blurb.text": {
    "properties": {
      "--vibe-color-hyperlink": "#00306b"
    }
  },
  "pet-policy-blurb.text": {
    "properties": {
      "--vibe-color-hyperlink": "#00306b"
    }
  },
  "propertyoverview.description": {
    "properties": {
      "--vibe-color-hyperlink": "#00306b"
    }
  },
  "schedule-tour-blurb.text": {
    "properties": {
      "--vibe-color-hyperlink": "#00306b"
    }
  },
  "virtual-tour-blurb.text": {
    "properties": {
      "--vibe-color-hyperlink": "#00306b"
    }
  }
};
